// helpers: base64 <-> ArrayBuffer
export function base64ToArrayBuffer(base64) {
  const binary = atob(base64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i=0;i<len;i++) bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
}
export function arrayBufferToBase64(buf) {
  const bytes = new Uint8Array(buf);
  let bin = '';
  for (let i=0;i<bytes.byteLength;i++) bin += String.fromCharCode(bytes[i]);
  return btoa(bin);
}

// import base64 32-byte key to CryptoKey
export async function importKeyFromBase64(b64Key) {
  const raw = base64ToArrayBuffer(b64Key);
  return await window.crypto.subtle.importKey(
    'raw',
    raw,
    { name: 'AES-GCM' },
    false,
    ['encrypt','decrypt']
  );
}

// encrypt: returns {ciphertext, iv, tag} all base64
export async function encryptWithKey(keyObj, plaintext) {
  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const enc = new TextEncoder().encode(plaintext);
  const cipherBuf = await window.crypto.subtle.encrypt(
    { name: 'AES-GCM', iv: iv, tagLength: 128 },
    keyObj,
    enc
  );
  const cipherBytes = new Uint8Array(cipherBuf);
  // split tag (last 16 bytes)
  const tag = cipherBytes.slice(cipherBytes.length - 16);
  const ciphertext = cipherBytes.slice(0, cipherBytes.length - 16);
  return {
    ciphertext: arrayBufferToBase64(ciphertext.buffer),
    iv: arrayBufferToBase64(iv.buffer),
    tag: arrayBufferToBase64(tag.buffer)
  };
}

// decrypt: payload {ciphertext, iv, tag} base64 => plaintext string
export async function decryptWithKey(keyObj, payload) {
  const ct = new Uint8Array(base64ToArrayBuffer(payload.ciphertext));
  const tag = new Uint8Array(base64ToArrayBuffer(payload.tag));
  const combined = new Uint8Array(ct.length + tag.length);
  combined.set(ct,0);
  combined.set(tag, ct.length);
  const iv = new Uint8Array(base64ToArrayBuffer(payload.iv));
  const decBuf = await window.crypto.subtle.decrypt(
    { name: 'AES-GCM', iv: iv, tagLength: 128 },
    keyObj,
    combined.buffer
  );
  return new TextDecoder().decode(decBuf);
}
